export type ReadingRoute={kind:'none'}|{kind:'invalid'}|{kind:'reading';sessionId:string};
const SESSION_ID_PATTERN=/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export class PrivateReadingAccessError extends Error{
  constructor(){super('This private reading link could not be verified.');this.name='PrivateReadingAccessError'}
}

export function readingRoute(pathname:string):ReadingRoute{
  if(!pathname.startsWith('/reading/'))return{kind:'none'};
  const match=pathname.match(/^\/reading\/([^/]+)\/?$/);if(!match||!SESSION_ID_PATTERN.test(match[1]??''))return{kind:'invalid'};
  return{kind:'reading',sessionId:match[1]!.toLowerCase()};
}

export function requireReadingMatch(expectedSessionId:string,actualSessionId:string):void{
  if(expectedSessionId!==actualSessionId)throw new PrivateReadingAccessError();
}

export function directReadingDestination(input:{paid_reading?:unknown;session:{status:string}},checkoutReturn=false):'paid_result'|'paid_loading'|'continue'{
  if(input.paid_reading)return'paid_result';
  if(checkoutReturn||['purchased','generating_paid','paid_ready'].includes(input.session.status))return'paid_loading';
  return'continue';
}

export function authorizedReadingDestination(expectedSessionId:string,input:{paid_reading?:unknown;session:{id:string;status:string}},checkoutReturn=false):'paid_result'|'paid_loading'|'continue'{
  requireReadingMatch(expectedSessionId,input.session.id);return directReadingDestination(input,checkoutReturn);
}
